import { render, staticRenderFns } from "./invoice-table.vue?vue&type=template&id=63922eaa&scoped=true&"
import script from "./invoice-table.vue?vue&type=script&lang=js&"
export * from "./invoice-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63922eaa",
  null
  
)

export default component.exports